import { Grid, GridProps, Text } from '@chakra-ui/react';
import { SweetShopArticleElementModel } from 'entities';
import React from 'react';

export type SweetShopArticlePageMainElementsSectionProps = {
    elements: SweetShopArticleElementModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>

export const SweetShopArticlePageMainElementsSection:
React.FC<SweetShopArticlePageMainElementsSectionProps> = ({
    elements,
    ...props
}) => (
    <Grid
        height="fit-content"
        gap="0.5rem"
        {...props}
    >
        {elements.map(({
            name,
            value,
            meassure,
        }) => (
            <Grid
                templateColumns="1fr auto"
                padding="1rem"
                background="#DDDDDD"
            >
                <Text fontSize="1rem" margin="auto 0">
                    {name}
                </Text>
                <Text fontSize="1rem" fontWeight={900} margin="auto 0">
                    {value}
                    {' '}
                    {meassure}
                </Text>
            </Grid>
        ))}
    </Grid>
);
